<template>
    <section class="background-holder">
        <v-container fluid fill-height class="background-holder__content">
            <v-row class="background-holder__content-rgba">
                <v-col class="background-holder__content-text">
                    <p>{{title}}</p>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
export default {
    name: 'AppBackGround',
    props: {
        title: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../styles/common/common.scss';

.background-holder__content {
    background: url("../assets/img/hero.webp");
    background-size: cover;
    background-position: center center;
    width: 100%;
    height: 30vh;
    &-rgba {
        height: 30vh;
        background: rgba(0, 0, 0, 0.6);
        display: flex;
        justify-content: center;
        align-items: center;
    }
    &-text {
        color: white;
        text-align: center;
        font-size: 28px;
        font-weight: bold;
    
        @include display_pc {
        font-size: 40px;
        }
    }
}
</style>